import React,{useState} from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { formatDate } from '../../../utils/commonFunctions';
import { Comments } from '../../commons';

type AppProps = {
    modal: boolean;
    toggleModal: () => void;
    data: any
    commentList: any
    handlePostComment: (data?: any) => void;
}

const InvoiceCommentsModal = ({modal,toggleModal,data,commentList,handlePostComment}:AppProps) => {
  const [commentText, setCommentText] = useState<string>('');
  const handleSubmitComment = (e: any) => {
    e.preventDefault();
    let finalData = {
        commentText: commentText,
         invoice_id: data?.id?data?.id:data?.others_id
    }
    handlePostComment(finalData)
    setCommentText("")
    }
    
   const handleCommentTextChange = (e: any) => {
    setCommentText(e.target.value);
    }
    
    const renderAllComments = () => {
    const finalComments = commentList?.map((data: any, index: number) => {
      return (
        <Comments
          key={index}
          commenterName={data?.user_details?.first_name+" "+data?.user_details?.last_name}
          commentTime={data?.created_at}
              commentText={data?.comments}
              image={data?.user_details?.profile_pic?.file_url}
        />
      )
    });

    return finalComments;
  }
  return (
      <>
       <Modal
              isOpen={modal}
              toggle={toggleModal}
              size="lg"
             
          >
               <ModalHeader toggle={toggleModal} >
           All Comments
              </ModalHeader>
              <ModalBody>
                 <div className="row">
                      <div className="col-md-12">
                          <div className='d-flex' style={{gap:"4%"}}>
                              {data?.voucher_invoice_number&&<div>
                             {data?.voucher_invoice_number && <h6>Invoice No.</h6>}
                                  <span>{data?.voucher_invoice_number}</span>
                              </div>}
                              
                              <div>
                                  <h6>Date of Invoice</h6>
                                 {data?.voucher_invoice_date&&<span>{formatDate(data?.voucher_invoice_date)}</span>} 
                                 {data?.date_of_invoice&&<span>{formatDate(data?.date_of_invoice)}</span>} 
                              </div>
                            { data?.net_amount && <div>
                               {data?.net_amount && <h6>Invoice Amount</h6>}
                                  <span>{data?.net_amount}</span>
                              </div>}
                              <div>
                               {data?.branch_details && <h6>Branch</h6>}
                                  <span>{data?.branch_details?.trade_name}</span>
                              </div>
                              
                          </div>
                      </div>
                  </div>
                  <form>
                  <div className="form-group mt-3">
                    <label htmlFor="commentBox"
                      className={commentText ? "active" : ""}
                    >Leave Comment</label>
                    <textarea
                      className={`form-control`}
                      name="text"
                      value={commentText}
                      autoFocus
                      onChange={(e) => handleCommentTextChange(e)}
                      onKeyPress={(e: any) => e.key === 'Enter' ? handleSubmitComment(e) : null}
                      style={{height:"100px"}}
                    />
                  </div>
                  </form>
                   <div className="text-right">
                  <span className="pointer" onClick={toggleModal}>Cancel</span>
                  <Button
                    color="primary ml-3"
                    onClick={(e: any) => { handleSubmitComment(e)}}
                  >
                     Post
                  </Button>
                </div>
              </ModalBody>
              <ModalFooter>
                   {!!commentList && commentList?.length > 0 ?
              <div className="w-100 comment-area">
                {renderAllComments()}
              </div> :
              <div className="w-100 text-center due-date-text">No Older Comments!</div>
            }
              </ModalFooter>
      </Modal>
      </>
  )
}

export default InvoiceCommentsModal